import type { CSSProperties } from 'react';
import { styled } from '@mui/material/styles';

const SKIP_LINK_ELEVATION = 16;

const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  borderWidth: 0,
} as const;

export const StyledSkipLink = styled('a')(({ theme }) => {
  const ring: CSSProperties = theme.focusVisible || {};
  const elevation = theme.shadows[SKIP_LINK_ELEVATION];

  return {
    ...visuallyHidden,
    '&:focus': {
      position: 'fixed',
      top: theme.spacing(1),
      left: theme.spacing(1),
      zIndex: theme.zIndex.skipLink,
      width: 'auto',
      height: 'auto',
      padding: theme.spacing(1, 2),
      margin: 0,
      overflow: 'visible',
      clip: 'auto',
      whiteSpace: 'normal',
      backgroundColor: theme.palette.common.white,
      color: theme.palette.tokens.blue[700],
      borderRadius: theme.spacing(0.75),
      boxShadow: elevation,
    },
    '&:focus-visible': {
      ...ring,
      boxShadow: [ring.boxShadow, elevation].filter(Boolean).join(', '),
    },
  };
});
